<template>
  <div class="prepareLessons">
    <div class="topTitle ">
      <span style="cursor: pointer;" @click="goback">返回 </span> / 团队题单 /
      {{ titleTd }}
    </div>

    <div class="tdmian">
      <el-row :gutter="20">
        <el-col
          :span="16"
          style="background:white;padding:10px 20px 20px 30px;border-radius:5px;"
        >
          <el-tabs v-model="activeName">
            <el-tab-pane label="题目列表" name="second">
              <div
                v-if="$store.state.user.identity === 1"
                style="height: calc(100vh - 239px);"
              >
                <el-table
                  :row-class-name="tableRowClassName"
                  ref="singleTable"
                  highlight-current-row
                  :data="tableData"
                  @row-click="rowChange"
                  style="width: 100%;"
                  :header-cell-style="{ color: '#333', background: 'white' }"
                  @selection-change="handleSelectionChange1"
                  height="calc(100% - 54px)"
                >
                  <el-table-column type="selection" width="55">
                  </el-table-column>
                  <el-table-column type="index" label="序号"> </el-table-column>

                  <el-table-column prop="code" label="题号" width="80">
                    <template slot-scope="scope">
                      <span>
                        <span>{{ scope.row.problemInfo.code }}</span>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="title"
                    label="名称"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <el-link
                        type="text"
                        @click="gonext(scope.row.problemInfo, scope.$index)"
                        >{{ scope.row.problemInfo.title }}</el-link
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="知识点标签"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <el-tag
                        size="mini"
                        style="margin-left:10px;margin-top:5px;"
                        v-for="item in scope.row.problemInfo.problemTagArr"
                        :key="item.id"
                      >
                        {{ item.tagInfo.title }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="problem_num"
                    label="通过人数"
                    width="100"
                  >
                    <!-- userNum -->
                    <template slot-scope="scope">
                      {{ scope.row.userNum }} / {{ tableDataStu.length }}
                    </template>
                  </el-table-column>

                  <el-table-column prop="" label="操作" width="100">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="mini"
                        @click="gonext(scope.row.problemInfo, scope.$index)"
                        >查看</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <div style="margin: 20px; text-align: right">
                  <el-pagination
                    @current-change="handleCurrent"
                    :current-page="page_no"
                    :page-size="page_size"
                    layout="total, prev, pager, next, jumper"
                    :total="total"
                  >
                  </el-pagination>
                </div>
              </div>
              <!-- 学生端 -->
              <div
                v-if="$store.state.user.identity === 2"
                style="height: calc(100vh - 239px);"
              >
                <el-table
                  ref="singleTable"
                  :data="tableData"
                  style="width: 100%;"
                  :header-cell-style="{ color: '#333', background: 'white' }"
                  height="calc(100% - 54px)"
                >
                  <!-- <el-table-column type="selection" width="55">
                  </el-table-column> -->
                  <el-table-column type="index" label="序号"> </el-table-column>
                  <el-table-column label="状态" width="80" align="center">
                    <template slot-scope="scope">
                      <svg
                        t="1658296902087"
                        v-if="scope.row.problemInfo.submissionInfo === 0"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="13040"
                        width="15"
                        height="15"
                      >
                        <path
                          d="M0 0h1024v1024H0V0z"
                          fill="#202425"
                          opacity=".01"
                          p-id="13041"
                        ></path>
                        <path
                          d="M955.733333 512c0 245.077333-198.656 443.733333-443.733333 443.733333S68.266667 757.077333 68.266667 512 266.922667 68.266667 512 68.266667s443.733333 198.656 443.733333 443.733333z"
                          fill="#11AA66"
                          p-id="13042"
                        ></path>
                        <path
                          d="M512 102.4C285.7984 102.4 102.4 285.7984 102.4 512s183.3984 409.6 409.6 409.6 409.6-183.3984 409.6-409.6S738.2016 102.4 512 102.4zM34.133333 512C34.133333 248.081067 248.081067 34.133333 512 34.133333s477.866667 213.947733 477.866667 477.866667-213.947733 477.866667-477.866667 477.866667S34.133333 775.918933 34.133333 512z"
                          fill="#11AA66"
                          p-id="13043"
                        ></path>
                        <path
                          d="M787.114667 339.285333a51.2 51.2 0 0 1 0 72.362667l-307.2 307.2a51.2 51.2 0 0 1-72.362667 0l-170.666667-170.666667a51.2 51.2 0 0 1 72.362667-72.362666L443.733333 610.235733l271.018667-271.018666a51.2 51.2 0 0 1 72.362667 0z"
                          fill="#FFFFFF"
                          p-id="13044"
                        ></path>
                      </svg>

                      <svg
                        t="1658296992015"
                        v-if="scope.row.problemInfo.submissionInfo === -1"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="13965"
                        width="15"
                        height="15"
                      >
                        <path
                          d="M827.392 195.584q65.536 65.536 97.792 147.456t32.256 167.936-32.256 167.936-97.792 147.456-147.456 98.304-167.936 32.768-168.448-32.768-147.968-98.304-98.304-147.456-32.768-167.936 32.768-167.936 98.304-147.456 147.968-97.792 168.448-32.256 167.936 32.256 147.456 97.792zM720.896 715.776q21.504-21.504 18.944-49.152t-24.064-49.152l-107.52-107.52 107.52-107.52q21.504-21.504 24.064-49.152t-18.944-49.152-51.712-21.504-51.712 21.504l-107.52 106.496-104.448-104.448q-21.504-20.48-49.152-23.04t-49.152 17.92q-21.504 21.504-21.504 52.224t21.504 52.224l104.448 104.448-104.448 104.448q-21.504 21.504-21.504 51.712t21.504 51.712 49.152 18.944 49.152-24.064l104.448-104.448 107.52 107.52q21.504 21.504 51.712 21.504t51.712-21.504z"
                          p-id="13966"
                          fill="#d81e06"
                        ></path>
                      </svg>

                      <div
                        v-if="
                          scope.row.problemInfo.submissionInfo != -1 &&
                            scope.row.problemInfo.submissionInfo != 0
                        "
                        style=" font-size: 14px;"
                        class="el-icon-minus"
                      ></div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="code" label="题号">
                    <template slot-scope="scope">
                      <span>
                        <span>{{ scope.row.problemInfo.code }}</span>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="title"
                    label="名称"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <el-link @click="gonext(scope.row.problemInfo)">{{
                        scope.row.problemInfo.title
                      }}</el-link>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="知识点标签"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <el-tag
                        size="mini"
                        style="margin-left:10px;margin-top:5px;"
                        v-for="item in scope.row.problemInfo.problemTagArr"
                        :key="item.id"
                      >
                        {{ item.tagInfo.title }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="problem_num" label="完成人数" width="100">
                    <template slot-scope="scope">
                      {{ scope.row.userNum }} / {{ tableDataStu.length }}
                    </template>
                  </el-table-column> -->

                  <el-table-column prop="" label="操作" width="100">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="mini"
                        @click="gonext(scope.row.problemInfo)"
                        >查看</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <div style="margin: 20px; text-align: right">
                  <el-pagination
                    @current-change="handleCurrent"
                    :current-page="page_no"
                    :page-size="page_size"
                    layout="total, prev, pager, next, jumper"
                    :total="total"
                  >
                  </el-pagination>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-col>
        <el-col :span="8" v-if="$store.state.user.identity === 1">
          <div style="width: 100%;background:white;border-radius:5px;">
            <div style="padding:20px;">
              <div class="clearfix">
                <div class="fl">
                  <div>
                    <div class="fl" style="font-size:16px;font-weight:bold;">
                      学员通过情况:
                    </div>
                    <div
                      class="fl"
                      style="margin-left:10px;font-size:16px;width: 130px;text-overflow: -o-ellipsis-lastline;overflow: hidden;	text-overflow: ellipsis;	display: -webkit-box;-webkit-line-clamp: 1;line-clamp: 1;-webkit-box-orient: vertical;"
                      v-if="current_problem"
                    >
                      {{ current_problem.problemInfo.title }}
                    </div>
                  </div>
                </div>
                <div class="fr">
                  <div class="clearfix">
                    <div class="fl" style="margin-top: 2px;margin-right: 5px;">
                      实时
                    </div>
                    <div class="fl">
                      <el-switch
                        @change="startChanegTable"
                        v-model="actiValue"
                        active-color="#13ce66"
                        inactive-color="grey"
                      >
                      </el-switch>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <el-button >开启</el-button> -->
            </div>

            <el-table
              @row-click="showSubmit"
              :data="userTdList"
              :header-cell-style="{ background: 'white' }"
              height="calc(100vh - 219px)"
            >
              <el-table-column
                prop="date"
                label="排名"
                width="55"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column prop="" label="头像" width="60">
                <template slot-scope="scope">
                  <div
                    style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;"
                  >
                    <img :src="scope.row.headImgUrl" style="width: 100%;" />
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="姓名"> </el-table-column>
              <el-table-column label="状态" width="80" align="center">
                <template slot-scope="scope">
                  <svg
                    t="1658296902087"
                    v-if="scope.row.pass_count === 1"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="13040"
                    width="15"
                    height="15"
                  >
                    <path
                      d="M0 0h1024v1024H0V0z"
                      fill="#202425"
                      opacity=".01"
                      p-id="13041"
                    ></path>
                    <path
                      d="M955.733333 512c0 245.077333-198.656 443.733333-443.733333 443.733333S68.266667 757.077333 68.266667 512 266.922667 68.266667 512 68.266667s443.733333 198.656 443.733333 443.733333z"
                      fill="#11AA66"
                      p-id="13042"
                    ></path>
                    <path
                      d="M512 102.4C285.7984 102.4 102.4 285.7984 102.4 512s183.3984 409.6 409.6 409.6 409.6-183.3984 409.6-409.6S738.2016 102.4 512 102.4zM34.133333 512C34.133333 248.081067 248.081067 34.133333 512 34.133333s477.866667 213.947733 477.866667 477.866667-213.947733 477.866667-477.866667 477.866667S34.133333 775.918933 34.133333 512z"
                      fill="#11AA66"
                      p-id="13043"
                    ></path>
                    <path
                      d="M787.114667 339.285333a51.2 51.2 0 0 1 0 72.362667l-307.2 307.2a51.2 51.2 0 0 1-72.362667 0l-170.666667-170.666667a51.2 51.2 0 0 1 72.362667-72.362666L443.733333 610.235733l271.018667-271.018666a51.2 51.2 0 0 1 72.362667 0z"
                      fill="#FFFFFF"
                      p-id="13044"
                    ></path>
                  </svg>
                  <svg
                    t="1658296992015"
                    v-if="scope.row.pass_count === 0"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="13965"
                    width="15"
                    height="15"
                  >
                    <path
                      d="M827.392 195.584q65.536 65.536 97.792 147.456t32.256 167.936-32.256 167.936-97.792 147.456-147.456 98.304-167.936 32.768-168.448-32.768-147.968-98.304-98.304-147.456-32.768-167.936 32.768-167.936 98.304-147.456 147.968-97.792 168.448-32.256 167.936 32.256 147.456 97.792zM720.896 715.776q21.504-21.504 18.944-49.152t-24.064-49.152l-107.52-107.52 107.52-107.52q21.504-21.504 24.064-49.152t-18.944-49.152-51.712-21.504-51.712 21.504l-107.52 106.496-104.448-104.448q-21.504-20.48-49.152-23.04t-49.152 17.92q-21.504 21.504-21.504 52.224t21.504 52.224l104.448 104.448-104.448 104.448q-21.504 21.504-21.504 51.712t21.504 51.712 49.152 18.944 49.152-24.064l104.448-104.448 107.52 107.52q21.504 21.504 51.712 21.504t51.712-21.504z"
                      p-id="13966"
                      fill="#d81e06"
                    ></path>
                  </svg>
                </template>
              </el-table-column>
              <el-table-column
                prop="submit_count"
                label="提交量"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="$store.state.user.identity === 2">
                    {{ scope.row.submit_count }}
                  </span>

                  <el-link
                    v-else
                    :underline="false"
                    type="primary"
                    @click="showSubmit(scope.row)"
                    >{{ scope.row.submit_count }}</el-link
                  >
                  <!-- this.$store.state.user.identity -->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- <div class="briefIntroduction_right_bottom">
            <span style="font-weight: bold;font-size: 18px;">我通过的题目</span>
            <div style="margin-top:10px">
              <el-progress :percentage="this.num"></el-progress>

            </div>
          </div> -->
        </el-col>
        <el-col :span="8" v-if="$store.state.user.identity === 2">
          <div style="box-sizing: border-box;">
            <div style="width: 100%;background:white;border-radius:5px;">
              <div class="briefIntroduction_right_bottom">
                <span style="font-weight: bold;font-size: 18px;"
                  >我通过的题目</span
                >
                <div style="margin-top:10px">
                  <!-- <el-progress :percentage="this.num"></el-progress> -->
                  <el-progress
                    :text-inside="true"
                    :stroke-width="16"
                    :percentage="setItemProgress()"
                    :format="setItemText()"
                  ></el-progress>
                </div>
              </div>
            </div>
            <div
              class="briefIntroduction_right_bottom"
              style="margin-top: 10px;height: calc(100vh - 257px); overflow-y: auto;box-sizing: border-box;"
            >
              <span style="font-weight: bold;font-size: 18px;">题单简介</span>
              <div style="margin-top:10px">
                <!-- <div v-html="$route.query.description"></div> -->
                <div v-html="description"></div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-drawer
      title="提单简介"
      style="border-color:transparent"
      size="50%"
      :visible.sync="drawer"
      direction="rtl"
    >
      <Tinymce v-model="content"></Tinymce>
    </el-drawer>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="80%">
      <el-form
        ref="form"
        :inline="true"
        :model="form"
        label-width="49px"
        size="mini"
      >
        <el-form-item label="标题">
          <el-input
            v-model="form.title_code"
            style="width:300px"
            placeholder="请输入标题"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="tchGetOjProblemListForProblemList"
            icon="el-icon-search"
            size="mini"
            >查询</el-button
          >
        </el-form-item>
      </el-form>

      <el-table
        :data="tableData1"
        stripe
        style="width: 100%;"
        :header-cell-style="{ background: '#f5f7fa' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="code" label="题号"> </el-table-column>
        <el-table-column prop="title" label="标题"> </el-table-column>
        <el-table-column label="标签">
          <template slot-scope="scope">
            <span v-for="item in scope.row.problemTagArr" :key="item.id">
              {{ item.tagInfo.title }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
      <div style="margin: 20px; text-align: right">
        <el-pagination
          @current-change="handleCurrent1"
          :current-page="page_no1"
          :page-size="page_size1"
          layout="total, prev, pager, next, jumper"
          :total="total1"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 提交记录代码 -->
    <!-- :size="isShowExample === false ? '43%' : '86%'" -->
    <el-drawer :visible.sync="drawerjl" :with-header="false" size="86%">
      <div class="clearfix">
        <div class="fl" style="width:calc(50% - 10px)">
          <el-table
            height="calc(100vh - 86px)"
            @row-click="showisShowExample"
            ref="subMitList"
            :data="subMitRecord"
            highlight-current-row
            style="width: 100%;"
            :header-cell-style="{ background: 'white', color: '#333' }"
          >
            <el-table-column
              prop="code"
              label="序号"
              align="center"
              width="100"
            >
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>

            <!-- <el-table-column label="状态" width="50" align="center">

              <template slot-scope="scope">

                <svg t="1658296902087" v-if="scope.row.result === 0" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="13040" width="15" height="15">
                  <path d="M0 0h1024v1024H0V0z" fill="#202425" opacity=".01" p-id="13041"></path>
                  <path
                    d="M955.733333 512c0 245.077333-198.656 443.733333-443.733333 443.733333S68.266667 757.077333 68.266667 512 266.922667 68.266667 512 68.266667s443.733333 198.656 443.733333 443.733333z"
                    fill="#11AA66" p-id="13042"></path>
                  <path
                    d="M512 102.4C285.7984 102.4 102.4 285.7984 102.4 512s183.3984 409.6 409.6 409.6 409.6-183.3984 409.6-409.6S738.2016 102.4 512 102.4zM34.133333 512C34.133333 248.081067 248.081067 34.133333 512 34.133333s477.866667 213.947733 477.866667 477.866667-213.947733 477.866667-477.866667 477.866667S34.133333 775.918933 34.133333 512z"
                    fill="#11AA66" p-id="13043"></path>
                  <path
                    d="M787.114667 339.285333a51.2 51.2 0 0 1 0 72.362667l-307.2 307.2a51.2 51.2 0 0 1-72.362667 0l-170.666667-170.666667a51.2 51.2 0 0 1 72.362667-72.362666L443.733333 610.235733l271.018667-271.018666a51.2 51.2 0 0 1 72.362667 0z"
                    fill="#FFFFFF" p-id="13044"></path>
                </svg>

                <svg t="1658296992015" v-else class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="13965" width="15" height="15">
                  <path
                    d="M827.392 195.584q65.536 65.536 97.792 147.456t32.256 167.936-32.256 167.936-97.792 147.456-147.456 98.304-167.936 32.768-168.448-32.768-147.968-98.304-98.304-147.456-32.768-167.936 32.768-167.936 98.304-147.456 147.968-97.792 168.448-32.256 167.936 32.256 147.456 97.792zM720.896 715.776q21.504-21.504 18.944-49.152t-24.064-49.152l-107.52-107.52 107.52-107.52q21.504-21.504 24.064-49.152t-18.944-49.152-51.712-21.504-51.712 21.504l-107.52 106.496-104.448-104.448q-21.504-20.48-49.152-23.04t-49.152 17.92q-21.504 21.504-21.504 52.224t21.504 52.224l104.448 104.448-104.448 104.448q-21.504 21.504-21.504 51.712t21.504 51.712 49.152 18.944 49.152-24.064l104.448-104.448 107.52 107.52q21.504 21.504 51.712 21.504t51.712-21.504z"
                    p-id="13966" fill="#d81e06"></path>
                </svg>

             
              </template>

            </el-table-column>
 -->

            <el-table-column label="耗时">
              <template slot-scope="scope">
                <span v-if="scope.row.time_cost === null">0ms</span>
                <span v-else>{{ scope.row.time_cost }}ms</span>
              </template>
            </el-table-column>
            <el-table-column label="内存">
              <template slot-scope="scope">
                <span>{{ scope.row.memory_cost / 1024 }}kb</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="created_time"
              label="提交时间"
              width="180"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column label="状态" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.result === -1">程序输出不正确</span>
                <span v-if="scope.row.result === 0">程序输出正确</span>
                <span v-if="scope.row.result === 1">超时</span>
                <span v-if="scope.row.result === 2">超时</span>
                <span v-if="scope.row.result === 3">内存超限</span>
                <span v-if="scope.row.result === 4">程序运行错误</span>
                <span v-if="scope.row.result === 5">系统错误</span>
                <span v-if="scope.row.result === -2">编译失败</span>
                <span v-if="scope.row.result === 6">等待测评</span>
                <span v-if="scope.row.result === 7">测评中</span>
                <span v-if="scope.row.result === 8">部分输出正确</span>
              </template>
            </el-table-column>
            <el-table-column prop="score" label="得分">
              <template slot-scope="scope">
                <span type="primary" @click="showisShowExample(scope.row)">{{
                  scope.row.score
                }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin: 20px; text-align: right">
            <el-pagination
              @current-change="handleCurrent2"
              :current-page="page_no2"
              :page-size="page_size2"
              layout="total, prev, pager, next, jumper"
              :total="total2"
            >
            </el-pagination>
          </div>
        </div>
        <div
          class="fr"
          style="width:calc(50% - 11px);border-left: 1px solid #ccc; min-height: 100vh; padding-left: 10px;padding-right: 10px;"
        >
          <!-- <div style="margin-top: 20px;" v-html="ojProblemInfo.description">
          </div> -->
          <div style="margin-top: 12px; font-size: 16px;" class="clearfix">
            <div class="fl">
              <span style="font-weight: bold;">问题:</span>
              <span style="margin-left:10px;">{{ ojProblemInfo.code }}</span>
              <span style="margin-left: 10px;">{{ ojProblemInfo.title }}</span>
            </div>
            <div class="fr">
              <div class="clearfix">
                <div
                  class="fl"
                  style="width: 20px;height: 20px;overflow: hidden;border-radius: 50%;margin-right: 10px;border: 1px solid gray;"
                >
                  <img :src="ojProblemInfo.headImgUrl" width="100%" />
                </div>
                <div class="fl" style="line-height: 22px; height: 22px;">
                  {{ ojProblemInfo.name }}
                </div>
              </div>
            </div>
          </div>
          <div
            style="margin-top: 12px;overflow-y: auto;border-radius:5px;font-size: 16px;"
          >
            <code-mirror v-model="code"></code-mirror>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-drawer title="题单简介" :visible.sync="moretxt">
      <div style="padding: 20px;">
        <span v-html="description"></span>
      </div>

      <!-- <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="moretxt = false">关闭</el-button>
      </span> -->
    </el-drawer>
  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce'
import {
  tchGetOjProblemListForProblemList,
  tchAddProblemForProblemList,
  tchDeleteProblemForProblemList,
  getProblemForTeamProblemList,
  stuGetProblemOfTeamPMList,
  getOneUserOjSubmissionListForTeam,
} from '@/api/educational.js'
import CodeMirror from '@/components/CodeMirror'

export default {
  components: {
    Tinymce,
    CodeMirror,
  },
  data() {
    return {
      problemAcceptNum: 0,
      actiValue: false,
      moretxt: false,
      total2: 0,
      page_no2: 1,
      page_size2: 10,
      ojProblemInfo: {
        description: '',
        code: '',
        title: '',
      },
      tableDataStu: [],
      description: '',
      code: '',
      drawerjlSize: '43',
      isShowExample: false,
      subMitRecord: [],
      subMitRecord1: [],

      userTdList: [],
      drawerjl: false,
      tableDataSoltUser: [],
      titleTd: '',
      num: 0,
      isShow1: false,
      isShow: false,
      form: {},
      problemlist_id: '',
      page_no1: 1,
      page_size1: 20,
      total1: 20,
      tableData1: [],
      dialogVisible: false,
      content: '',
      drawer: false,
      page_no: 1,
      page_size: 10,
      total: 1,
      activeName: 'second',
      tableData: [],
      multipleSelection: [],
      multipleSelection1: [],
      oj_problem_id: '',
      userCode: '',
      current_problem: '',
      startTable: null,
      TableIndex: 0,
    }
  },
  watch: {
    drawerjl(val) {
      console.log(val, 52632323)
      if (val === false) {
        console.log(111)
        this.isShowExample = false
      }
    },
  },
  destroyed() {
    // 在页面销毁后，清除计时器
    // this.$route.meta.keepAlive = false
    clearInterval(this.startTable) //清除计时器
    this.startTable = null
  },
  created() {
    console.log(this.$route.query)
    if (this.$route.query.TableIndex === undefined) {
      this.TableIndex = 0
    } else {
      this.TableIndex = this.$route.query.TableIndex
    }
    // console.log(this.$store.state.user.identity, 451223);
    // if (this.$store.state.user.identity === 1) {
    //   this.$route.meta.keepAlive = true
    //   console.log(this.$route.meta.keepAlive, 451223);
    // } else {
    //   this.$route.meta.keepAlive = false

    // }
    if (this.$route.query.practice) {
      this.isShow = false
      this.isShow1 = true
    } else {
      this.isShow = true
      this.isShow1 = false
    }
    this.problemlist_id = this.$route.query.problemlist_id
    if (this.$route.query.type1 === 'tuanduitidan') {
      this.page_no = Number(this.$route.query.page_notd)
      this.page_size = Number(this.$route.query.page_sizetd)
      // if (this.$route.query.practice) {
      //   this.isShow = false
      //   this.isShow1 = true
      // } else {
      //   this.isShow = true
      //   this.isShow1 = false
      // }
      // this.problemlist_id = this.$route.query.problemlist_id
      // this.getProblemForTeamProblemList()
    }
  },
  mounted() {
    console.log(this.$store.state.user.identity, 56532)
    console.log(this.$route.query.type, 5632323)
    this.titleTd = sessionStorage.getItem('tidan')
    this.description = sessionStorage.getItem('description')
    this.getProblemForTeamProblemList()
  },
  methods: {
    moreTxt() {
      this.moretxt = true
    },
    //查看提交代码
    showSubmit(row) {
      console.log(row, 451312)
      this.ojProblemInfo.name = row.name
      this.ojProblemInfo.headImgUrl = row.headImgUrl
      if (this.$store.state.user.identity === 1) {
        this.userCode = row.userCode
        this.oj_problem_id = row.oj_problem_id

        console.log(row, 12145)
        getOneUserOjSubmissionListForTeam({
          team_problemlist_relation_id: this.$route.query
            .teamProblemlistRelationId,
          problem_id: row.oj_problem_id,
          code: row.userCode,
          page_no: this.page_no2,
          page_size: this.page_size2,
        }).then((res) => {
          console.log(res, 45121)
          this.subMitRecord = res.submissionList
          this.$refs.subMitList.setCurrentRow(this.subMitRecord[0])
          this.code = this.subMitRecord[0].code
          this.total2 = res.total
        })
        this.drawerjl = true
      }
    },
    showisShowExample(row) {
      this.code = row.code
      this.isShowExample = true
    },
    handleCurrent2(val) {
      this.page_no2 = val
      getOneUserOjSubmissionListForTeam({
        team_problemlist_relation_id: this.$route.query
          .teamProblemlistRelationId,
        problem_id: this.oj_problem_id,
        code: this.userCode,
        page_no: this.page_no2,
        page_size: this.page_size2,
      }).then((res) => {
        console.log(res, 45121)
        this.subMitRecord = res.submissionList
        this.$refs.subMitList.setCurrentRow(this.subMitRecord[0])
        this.code = this.subMitRecord[0].code

        this.total2 = res.total
      })
    },
    setItemProgress() {
      // if (data.pass_count > data.problemnum) {
      if (this.problemAcceptNum > this.$route.query.problem_num) {
        return 100
      } else {
        return parseInt(
          (this.problemAcceptNum / this.$route.query.problem_num).toFixed(1) *
            100
        )
      }
    },
    setItemText() {
      return () => {
        return +this.problemAcceptNum + ' / ' + this.$route.query.problem_num
      }
    },

    gonext(row, index) {
      this.TableIndex = index
      this.$router.push({
        name: 'questionBankDetails',
        query: {
          id: row.id,
          type1: 'tuanduitidan',
          page_notd: this.page_no,
          page_sizetd: this.page_size,
          teamProblemlistRelationId: this.$route.query
            .teamProblemlistRelationId,
          problemlist_id: this.$route.query.problemlist_id,
          practice: this.$route.query.practice,
          problemAcceptNum: this.$route.query.problemAcceptNum,
          problem_num: this.$route.query.problem_num,
          title: this.$route.query.title,
          team: this.$route.query.team,
          type: this.$route.query.type,
          description: this.$route.query.description,
          ProblemLength: this.$route.query.ProblemLength,
          page_no: this.$route.query.page_no,
          page_size: this.$route.query.page_size,
          TableIndex: this.TableIndex,
        },
      })
    },
    dels() {
      if (this.multipleSelection1.length === 0) {
        this.$message.warning('请选中再进行删除!')
        return false
      }
      tchDeleteProblemForProblemList({
        problemlist_id: this.problemlist_id,
        problemIds: JSON.stringify(this.multipleSelection1),
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!',
        })
        this.getProblemForTeamProblemList()
      })
    },
    handleSelectionChange1(val) {
      console.log(val)
      let arr1 = []
      this.multipleSelection1 = []
      for (let k = 0; k < val.length; k++) {
        arr1.push(val[k].id)
        console.log(arr1)
        this.multipleSelection1 = arr1
      }
      console.log(this.multipleSelection1)
    },
    del(row) {
      console.log(row.id)
      let ids = []
      ids.push(row.id)
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          tchDeleteProblemForProblemList({
            problemlist_id: this.problemlist_id,
            problemIds: JSON.stringify(ids),
          }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.getProblemForTeamProblemList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    startChanegTable() {
      if (this.actiValue === true) {
        // this.$route.meta.keepAlive = true
        this.startTable = setInterval(() => {
          this.getProblemForTeamProblemList()
        }, 10000)
      } else {
        // this.$route.meta.keepAlive = false
        clearInterval(this.startTable) //清除计时器
        this.startTable = null
      }
    },

    getProblemForTeamProblemList() {
      console.log(JSON.parse(this.$route.query.team), 565321111)
      const temporaryFun =
        this.$store.state.user.identity === 1
          ? getProblemForTeamProblemList
          : stuGetProblemOfTeamPMList
      temporaryFun({
        // team_id:
        //   this.$store.state.user.identity === 1
        //     ? JSON.parse(this.$route.query.team).id
        //     : JSON.parse(this.$route.query.team).oj_team_id,
        // problemlist_id: this.problemlist_id,
        team_problemlist_relation_id: this.$route.query
          .teamProblemlistRelationId,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        this.tableData = res.problemListRelationList
        this.tableDataStu = res.stuNum
        if (res.problemAcceptNum !== undefined) {
          this.problemAcceptNum = res.problemAcceptNum
        }
        this.$refs.singleTable.setCurrentRow(this.tableData[this.TableIndex])
        this.current_problem = this.tableData[this.TableIndex]
        this.total = res.total
        this.tableData.map((item) => {
          if (item.submissionInfo) {
            if (item.submissionInfo.length === 0) {
              item.userNum = 0
            } else {
              let num = 1
              item.submissionInfo.map((item1) => {
                item1.oj_problem_id = item.oj_problem_id
                if (item1.pass_count === 1) {
                  item.userNum = num++
                } else {
                  item.userNum = num - 1
                }
              })
            }
          }
        })
        if (this.tableData[this.TableIndex].submissionInfo) {
          this.userTdList = this.tableData[this.TableIndex].submissionInfo
        }
        // this.ojProblemInfo.description = this.tableData[this.TableIndex].problemInfo.description
        this.ojProblemInfo.code = this.tableData[
          this.TableIndex
        ].problemInfo.code
        this.ojProblemInfo.title = this.tableData[
          this.TableIndex
        ].problemInfo.title
        // this.ojProblemInfo.name = this.tableData[this.TableIndex].problemInfo.name
        // this.ojProblemInfo.headImgUrl = this.tableData[this.TableIndex].problemInfo.headImgUrl
      })
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    //题单高亮
    rowChange(row) {
      console.log(row.index, 4632333)
      this.TableIndex = row.index
      console.log(row, 432323)
      this.current_problem = row
      // userTdList
      this.userTdList = []
      if (row.submissionInfo) {
        this.userTdList = row.submissionInfo
      }
      // this.ojProblemInfo.description = row.problemInfo.description
      this.ojProblemInfo.code = row.problemInfo.code
      this.ojProblemInfo.title = row.problemInfo.title
      this.ojProblemInfo.name = row.problemInfo.name
      this.ojProblemInfo.headImgUrl = row.problemInfo.headImgUrl
      console.log(this.ojProblemInfo.description, 432323)

      // this.userTdList.map((item3) => {
      //   item3.problemnum = row.problemListInfo.problem_num
      // })
    },
    peactic() {
      console.log(123)
    },
    submit() {
      tchAddProblemForProblemList({
        problemlist_id: this.problemlist_id,
        problemIds: JSON.stringify(this.multipleSelection),
      }).then((res) => {
        console.log(res)
        this.$message.success('添加成功!')
        this.dialogVisible = false
        this.getProblemForTeamProblemList()
      })
    },
    handleSelectionChange(val) {
      console.log(val)
      let arr = []
      this.multipleSelection = []
      for (let k = 0; k < val.length; k++) {
        arr.push(val[k].id)
        console.log(arr)
        this.multipleSelection = arr
      }
      console.log(this.multipleSelection)
    },
    addList() {
      this.dialogVisible = true
      this.tchGetOjProblemListForProblemList()
    },
    tchGetOjProblemListForProblemList() {
      tchGetOjProblemListForProblemList({
        // title_code:
        ...this.form,
        problemlist_id: this.problemlist_id,
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log(res)
        this.tableData1 = res.ojProblemList
        this.total1 = res.total
      })
    },
    edit() {
      this.drawer = true
    },
    handleCurrent(val) {
      this.TableIndex = 0
      this.page_no = val
      this.getProblemForTeamProblemList()
    },
    handleCurrent1(val) {
      this.page_no1 = val
      this.tchGetOjProblemListForProblemList()
    },
    goback() {
      // this.$route.meta.keepAlive = false
      // console.log(this.$route.meta.keepAlive, 56232);
      clearInterval(this.startTable) //清除计时器
      this.startTable = null
      if (this.$route.query.type === 'tuandui1') {
        this.$router.push({
          name: 'teamDetails',
          query: {
            activeName: 'third',
            page_no: this.$route.query.page_no,
            page_size: this.$route.query.page_size,
            team: this.$route.query.team,
            type: this.$route.query.type,
            ProblemLength: this.$route.query.ProblemLength,
            teamProblemlistRelationId: this.$route.query
              .teamProblemlistRelationId,
          },
        })
      } else if (this.$route.query.type === 'tuandui2') {
        this.$router.push({
          name: 'teamStyDetails',
          query: {
            activeName: 'third',
            team: this.$route.query.team,
            page_no: this.$route.query.page_no,
            page_size: this.$route.query.page_size,
            teamProblemlistRelationId: this.$route.query
              .teamProblemlistRelationId,
          },
        })
      } else {
        this.$router.go(-1)
        sessionStorage.setItem('activeName', 'third')
      }

      // else {
      //   this.$router.go(-1)
      //   sessionStorage.setItem('activeName', 'third')
      // }
      //   this.$router.push({
      //   name: 'teamDetails',
      //   query: {

      //   }
      // })
    },
  },
}
</script>

<style lang="scss" scoped>
.prepareLessons {
  margin: 10px;
  min-height: calc(100vh - 120px);
  /* background: #fff; */
  border-radius: 5px;
  overflow: hidden;
}

.briefIntroduction_right {
  padding: 20px;
  padding-top: 0px;
  background: #f9f9f9;
  border-radius: 5px;
  overflow: hidden;
}

.briefIntroduction_right li {
  margin-top: 20px;
  font-size: 16px;
  font-weight: 500;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: '';
  display: block;
  visibility: hidden;
  clear: both;
}

.briefIntroduction_right_bottom {
  padding: 20px;
  // background: #f9f9f9;
  background: #fff;

  border-radius: 5px;
  overflow: hidden;
}

.topTitle {
  height: 60px;
  background: #fff;

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.tdmian {
  margin-top: 10px;
  border-radius: 5px;
  // height: calc(100vh - 150px);
  // overflow: hidden;
}

::v-deep .el-drawer__header > :first-child {
  outline: none;
}

//两行或多行显示
.txtjj {
  width: calc(100% - 67px);
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden; //溢出内容隐藏
  text-overflow: ellipsis; //文本溢出部分用省略号表示
  display: -webkit-box; //特别显示模式
  -webkit-line-clamp: 1; //行数
  line-clamp: 1;
  -webkit-box-orient: vertical; //盒子中内容竖直排列
}

// /deep/ .CodeMirror-scroll {

//   height: calc(100vh - 102px);

// }
/deep/ .el-date-editor .el-range-separator {
  padding: 0 16px;
}

/deep/.el-dialog {
  border-radius: 10px !important;
}

/deep/ .tox-tinymce {
  min-height: calc(100vh - 208px);
}

/deep/.el-dialog {
  border-radius: 10px !important;
}

/deep/ .CodeMirror-scroll {
  height: calc(92.2vh) !important;
}
</style>
